document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.kv-pack').forEach(initPackSelector);
});

function initPackSelector(root) {
  const radios = root.querySelectorAll('.kv-pack__radio');
  const hiddenInput = root.querySelector('.kv-pack__variant-id');
  const ctaPrice = root.querySelector('.kv-pack__cta-price');
  const cta = root.querySelector('.kv-pack__cta');
  const shippingBox = root.querySelector('.kv-pack__shipping');
  const shippingFill = root.querySelector('.kv-pack__shipping-fill');
  const shippingText = root.querySelector('.kv-pack__shipping-text');
  const shippingThreshold = shippingBox ? Number(shippingBox.dataset.threshold) : 40000;
  const stickyBar = root.querySelector('.kv-pack__sticky-bar');
  const stickyPrice = root.querySelector('.kv-pack__sticky-price');
  const stickyCta = root.querySelector('.kv-pack__sticky-cta');

  radios.forEach((radio) => {
    radio.addEventListener('change', () => {
      radios.forEach((r) => {
        r.closest('.kv-pack__option').classList.toggle('kv-pack__option--selected', r.checked);
      });

      if (!radio.checked) return;

      if (hiddenInput) hiddenInput.value = radio.value;

      const price = Number(radio.dataset.price);
      const comparePrice = Number(radio.dataset.comparePrice);

      if (ctaPrice) {
        let html = formatCLP(price);
        if (comparePrice > price) {
          html += ` <s>${formatCLP(comparePrice)}</s>`;
        }
        ctaPrice.innerHTML = html;
      }

      if (cta) cta.disabled = radio.disabled;
      if (stickyPrice) stickyPrice.textContent = formatCLP(price);
      if (stickyCta) stickyCta.disabled = radio.disabled;

      if (shippingFill && shippingText) {
        const remaining = Math.max(0, shippingThreshold - price);
        const percent = Math.min(100, (price / shippingThreshold) * 100);
        shippingFill.style.width = percent + '%';
        shippingText.textContent =
          remaining <= 0
            ? '🚚 ¡Envío gratis incluido en este plan!'
            : '🚚 Te faltan ' + formatCLP(remaining) + ' para envío gratis';
      }
    });
  });

  if (stickyBar && cta && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          stickyBar.classList.toggle('kv-pack__sticky-bar--visible', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    observer.observe(cta);
  }
}

function formatCLP(amount) {
  return '$' + Math.round(amount).toLocaleString('es-CL');
}
